import React from 'react';

import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from '@/components/ui/dropdown-menu';
import {
  isReportsLayoutMode,
  type ReportsLayoutMode,
} from 'components/Reports/hooks/useReportsLayoutMode';

type SitrepLayoutMenuItemsProps = {
  layoutMode: ReportsLayoutMode;
  onLayoutModeChange: (mode: ReportsLayoutMode) => void;
};

/** Radio items for Tabs / Document, used inside a report kebab. */
const SitrepLayoutMenuItems: React.FC<SitrepLayoutMenuItemsProps> = ({
  layoutMode,
  onLayoutModeChange,
}) => {
  return (
    <DropdownMenuRadioGroup
      value={layoutMode}
      onValueChange={(next) => {
        if (isReportsLayoutMode(next)) {
          onLayoutModeChange(next);
        }
      }}
    >
      <DropdownMenuLabel>Layout</DropdownMenuLabel>
      <DropdownMenuRadioItem value="tabs" data-testid="reports-layout-tabs">
        Tabs
      </DropdownMenuRadioItem>
      <DropdownMenuRadioItem
        value="document"
        data-testid="reports-layout-document"
      >
        Document
      </DropdownMenuRadioItem>
    </DropdownMenuRadioGroup>
  );
};

export default SitrepLayoutMenuItems;
